// extracted by mini-css-extract-plugin
export default {"imgbox":"SubBanner_imgbox__iN37J","center":"SubBanner_center__ho7eU","head":"SubBanner_head__inwf4","subHead":"SubBanner_subHead__XXDve"};